module.exports = __webpack_public_path__ + "static/media/communication_flows.406f8e4c.png";